import axios from 'axios'

// Výchozí nastavení
//const ServiceBaseURL = 'https://eagri.cz/ssl/app/uhul/mtest/ws.KN/ServiceKNM.svc';
var ServiceBaseURL = '';
var ServiceWithCredentials = true;
var ServiceHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

var apiClient

/* const apiClient = axios.create({
    baseURL: ServiceBaseURL,
    withCredentials: true, // This is the default
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    responseType: 'text',
}) */

export default {

    // Inicializace
    Init(url) {
        ServiceBaseURL = url;
        apiClient = axios.create({
            baseURL: ServiceBaseURL,
            withCredentials: ServiceWithCredentials,
            headers: ServiceHeaders,
        })
    },

    // Parcela výpis 
    ParVypis(Id, datumK) {
        return apiClient.get(`/ParVypis`, {
            params: {
                Id: Id,
                datumK: datumK,
            }
        })
    },
    // lv výpis 
    LvVypis(Id, katastrUzemiKod, lvCislo, datumK) {
        return apiClient.get(`/LvVypis`, {
            params: {
                Id: Id,
                katastrUzemiKod: katastrUzemiKod,
                lvCislo: lvCislo,
                datumK: datumK,
            }
        })
    },

    // Stavba výpis 
    StaVypis(Id, datumK) {
        return apiClient.get(`/StaVypis`, {
            params: {
                Id: Id,
                datumK: datumK,
            }
        })
    },

    // Pravo stavby výpis 
    PraVypis(Id, datumK) {
        return apiClient.get(`/PraVypis`, {
            params: {
                Id: Id,
                datumK: datumK,
            }
        })
    },

    // Parcela - hledat 
    ParNajdi(Id, katastrUzemiKod, kmenoveCislo, poddeleni, datumK) {
        return apiClient.get(`/ParNajdi`, {
            params: {
                Id: Id,
                katastrUzemiKod: katastrUzemiKod,
                kmenoveCislo: kmenoveCislo,
                poddeleni: poddeleni,
                datumK: datumK,
            }
        })
    },
    // Stavba - hledat 
    StaNajdi(Id, castObceKod, typStavbyKod, cisloDomovni, datumK) {
        return apiClient.get(`/StaNajdi`, {
            params: {
                Id: Id,
                castObceKod: castObceKod,
                typStavbyKod: typStavbyKod,
                cisloDomovni: cisloDomovni,
                datumK: datumK,
            }
        })
    },
    // Právo stavby - hledat 
    PraNajdi(Id, parcelaId, katastrUzemiKod, kmenoveCislo, poddeleni, datumK) {
        return apiClient.get(`/PraNajdi`, {
            params: {
                Id: Id,
                parcelaId: parcelaId,
                katastrUzemiKod: katastrUzemiKod,
                kmenoveCislo: kmenoveCislo,
                poddeleni: poddeleni,
                datumK: datumK,
            }
        })
    },

    // Parcela - opsaný obdelník
    ParMbr(Id, EpsgCode) {
        return apiClient.get(`/ParMbr`, {
            params: {
                Id: Id,
                EpsgCode: EpsgCode,
            }
        })
    },

    // Parcela - definiční bod
    ParDefBod(Id, EpsgCode) {
        return apiClient.get(`/ParDefBod`, {
            params: {
                Id: Id,
                EpsgCode: EpsgCode,
            }
        })
    },

    // Seznam parcel pro zadaný obdelník - z databáze
    BboxPar(EpsgCode, Xmin, Ymin, Xmax, Ymax, Vypis) {
        return apiClient.get(`/BboxPar`, {
            params: {
                EpsgCode: EpsgCode,
                Xmin: Xmin,
                Ymin: Ymin,
                Xmax: Xmax,
                Ymax: Ymax,
                Vypis: Vypis,
            }
        })
    },

    // Seznam definičních bodů pro zadaný obdelník - z databáze
    BboxParDefBod(EpsgCode, Xmin, Ymin, Xmax, Ymax, Vypis) {
        return apiClient.get(`/BboxParDefBod`, {
            params: {
                EpsgCode: EpsgCode,
                Xmin: Xmin,
                Ymin: Ymin,
                Xmax: Xmax,
                Ymax: Ymax,
                Vypis: Vypis,
            }
        })
    },

    // Parcela podle zadané souřadnice
    PointPar(EpsgCode, X, Y, Vypis) {
        return apiClient.get(`/PointPar`, {
            params: {
                EpsgCode: EpsgCode,
                X: X,
                Y: Y,
                Vypis: Vypis,
            }
        })
    },




}

